<template>
  <div>
    <div class="container">
      <h1>Willkommen, {{ cn }}!</h1>
      <p>
        Verwalte deine Diplomarbeit von der ersten Konzeption bis zur
        Enddokumentation mit allen Funktionen, die du brauchst, um fokussiert und
        erfolgreich zu sein.
      </p>
    </div>

    <div class="container2">
      <div class="stats-box">
        <div class="left-section">
          <div class="kachel">
            <span class="material-symbols-outlined icon">folder_open</span>
            <p>
              Aktuell sind {{ totalProjects }} Projekte verfügbar, an denen du teilnehmen kannst.
            </p>
          </div>
          <div class="kachel">
            <span class="material-symbols-outlined icon">folder_copy</span>
            <p>
              Bereits {{ totalDocuments }} Dokumente stehen im Archiv bereit –
              finde Inspiration!
            </p>
          </div>
          <div class="kachel">
            <span class="material-symbols-outlined icon">group</span>
            <p>
              Unsere Plattform wird aktuell von 94 Schülern und 85 Lehrern
              genutzt.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import { ref, computed, onMounted } from "vue"
import { useAuthenticationStore } from "@/stores/useAuthStore"

export default {
  name: "Projekte",
  setup() {
    const authStore = useAuthenticationStore()
    const totalProjects = ref(0)
    const totalDocuments = ref(0)

    // computed => liest dynamisch den Store-Wert
    const cn = computed(() => authStore.cn)

    const fetchTotalProjects = async () => {
      try {
        const response = await axios.get(`${process.env.VUE_APP_BACKEND}/diplomdb/api/projects`, {
          withCredentials: true,
        })
        console.log("Projekte-Daten:", response.data) // Debug-Log
        totalProjects.value = response.data.length
      } catch (error) {
        console.error("FEHLER beim Laden der Projekte:", error)
      }
    }

    const fetchTotalDocuments = async () => {
      try {
        const response = await axios.get(`${process.env.VUE_APP_BACKEND}/diplomdb/api/documents`, {
          withCredentials: true,
        })
        console.log("Dokumente-Daten:", response.data) // Debug-Log
        totalDocuments.value = response.data.length
      } catch (error) {
        console.error("FEHLER beim Laden der Dokumente:", error)
      }
    }

    onMounted(() => {
      fetchTotalProjects()
      fetchTotalDocuments()
    })

    return {
      cn,
      totalProjects,
      totalDocuments,
    }
  },
}
</script>

<style scoped>
/* ---------- Hero / Begrüßung ---------- */
.container{
  background:linear-gradient(90deg,#cedaff 0%,#e3f4ff 100%);
  height:90vh;
  display:flex;
  flex-direction:column;
  justify-content:center;
  padding-left:13%;
}
.container h1{margin:0;font-size:40px;color:#000;}
.container p{margin-top:1.5rem;max-width:600px;font-size:20px;font-weight:bold;line-height:1.6;color:#2300ff;}

/* ---------- KPI-Bereich ---------- */
.container2{
  background:#fff;                 /* weißer Hintergrund */
  height:35vh;                     /* feste Höhe -> exaktes Zentrieren möglich  */
  display:flex;
  justify-content:center;          /* horizontal zentriert */
  align-items:center;              /* vertikal zentriert  */
  padding:0 2rem;                  /* nur seitlicher Puffer */
}

.stats-box{
  width:100%;
  max-width:1400px;
  display:flex;
  flex-wrap:wrap;
  column-gap:3rem;                 /* Abstand zwischen Spalten */
  row-gap:3rem;                    /* größerer Abstand zwischen Zeilen */
  justify-content:center;
}

.kachel{
  background:transparent;          /* kein Hintergrund */
  box-shadow:none;                 /* kein Schatten   */
  padding:24px 28px;
  display:flex;
  align-items:center;
  gap:1.25rem;
  flex:1 1 420px;                  /* breite Karten   */
  transition:transform .25s ease;
}
.kachel:hover{transform:translateY(-4px);}   /* leichter Hover-Lift */

.icon{
  font-size:2.8rem;
  color:#2300ff;                  /* Icon-Farbe      */
}

.kachel p{
  margin:0;
  font-size:1.1rem;
  line-height:1.5;
  color:#374151;
  flex:1;
}

/* ---------- Responsive ---------- */
@media (max-width:768px){
  .stats-box{column-gap:1.5rem;row-gap:2rem;}
  .kachel{flex:1 1 100%;}
  .kachel p{font-size:1rem;}
}
</style>
